import { render, staticRenderFns } from "./TripsMonitoring.vue?vue&type=template&id=2050902e&"
import script from "./TripsMonitoring.vue?vue&type=script&lang=js&"
export * from "./TripsMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./TripsMonitoring.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
